import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../components/layout/Layout";
import Spinner from "../components/ui/Spinner";
import HomePage from "../pages/HomePage";
import { PBAM_PROGRAMS } from "../config/pbamPrograms";
import { REGIONAL_PROGRAMS } from "../config/regionalPrograms";

/**
 * Главная грузится сразу, остальные страницы — по требованию.
 * Раньше все 17 страниц (вместе с текстами и PDF-импортами) попадали
 * в один бандл.
 */
const OrganizationPage = lazy(() => import("../pages/OrganizationPage"));
const TajikistanPage = lazy(() => import("../pages/TajikistanPage"));
const IfasPage = lazy(() => import("../pages/IfasPage"));
const ActivityPage = lazy(() => import("../pages/ActivityPage"));
const PublicationsPage = lazy(() => import("../pages/PublicationsPage"));
const PbamProgramPage = lazy(() => import("../pages/PbamProgramPage"));
const RegionalProgramPage = lazy(() => import("../pages/RegionalProgramPage"));
const NewsListPage = lazy(() => import("../pages/NewsListPage"));
const NewsDetailPage = lazy(() => import("../pages/NewsDetailPage"));
const ReportsPage = lazy(() => import("../pages/ReportsPage"));
const AnnouncementsPage = lazy(() => import("../pages/AnnouncementsPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

export function AppRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />

          <Route path="organization" element={<OrganizationPage />} />
          <Route path="tajikistan" element={<TajikistanPage />} />
          <Route path="project" element={<IfasPage />} />
          <Route path="work" element={<ActivityPage />} />
          <Route path="publication" element={<PublicationsPage />} />

          {/* Адреса вида /pbam1 сохранены — по ним есть внешние ссылки. */}
          {PBAM_PROGRAMS.map((program) => (
            <Route
              key={program.slug}
              path={program.path}
              element={<PbamProgramPage slug={program.slug} />}
            />
          ))}

          {REGIONAL_PROGRAMS.map((program) => (
            <Route
              key={program.slug}
              path={program.path}
              element={<RegionalProgramPage slug={program.slug} />}
            />
          ))}

          <Route path="news">
            <Route index element={<NewsListPage />} />
            <Route path="static/:staticId" element={<NewsDetailPage />} />
            <Route path=":id" element={<NewsDetailPage />} />
          </Route>

          <Route path="reports" element={<ReportsPage />} />
          <Route path="announcements" element={<AnnouncementsPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
